export function getRoleAccess(profile: any): any[] | null {
  const role = Array.isArray(profile?.role) ? profile.role[0] : profile?.role;
  const access = role?.access ?? profile?.access;

  return Array.isArray(access) ? access : null;
}

export function normalizeId(id: string): string {
  if (!id) return '';
  // Map security-command-center to executive-view
  if (id === 'security-command-center') {
    return 'executive-view';
  }
  // Map risk-impact-management to risk-resilience
  if (id === 'risk-impact-management') {
    return 'risk-resilience';
  }
  // Map compliance-governance-module to compliance-governance
  if (id === 'compliance-governance-module') {
    return 'compliance-governance';
  }
  // Map control-and-task-operations to control-task-operations
  if (id === 'control-and-task-operations' || id === 'controlTaskOperations') {
    return 'control-task-operations';
  }
  // Map posture-executive-dashboard to executive-dashboard
  if (id === 'posture-executive-dashboard') {
    return 'executive-dashboard';
  }
  // Map settings_module or settings to settings-module
  if (id === 'settings_module' || id === 'settings') {
    return 'settings-module';
  }
  return id;
}

export function getAccessValue(
  profile: any,
  targetId: string,
  subTargetId?: string,
): string | null {
  const accessList = getRoleAccess(profile);
  if (!accessList || !Array.isArray(accessList)) {
    return null;
  }

  const normTarget = normalizeId(targetId);
  const normSubTarget = subTargetId ? normalizeId(subTargetId) : null;

  // 1. If subTargetId is provided, first search specifically for subTargetId anywhere in accessList
  if (normSubTarget) {
    for (const item of accessList) {
      const res = findNodeAccess(item, normSubTarget);
      if (res !== null) {
        return res;
      }
    }
  }

  // 2. Otherwise search for targetId (module/platform) anywhere in accessList
  if (normTarget) {
    for (const item of accessList) {
      const res = findNodeAccess(item, normTarget);
      if (res !== null) {
        return res;
      }
    }
  }

  return null;
}

function findNodeAccess(
  node: any,
  targetId: string,
  parentAccess: string | null = null,
): string | null {
  if (!node) return null;

  const nodeName = normalizeId(node?._id ?? node?.moduleId);
  const currentAccess = node?.access || parentAccess;

  if (nodeName === targetId) {
    return node?.access || parentAccess;
  }

  const subNodes = [
    ...(Array.isArray(node?.children) ? node.children : []),
    ...(Array.isArray(node?.modules) ? node.modules : []),
    ...(Array.isArray(node?.items) ? node.items : []),
  ];

  for (const sub of subNodes) {
    const res = findNodeAccess(sub, targetId, currentAccess);
    if (res !== null) {
      return res;
    }
  }

  return null;
}

